<template>
  <div>
    <h1>{{ $t("global.reports") }}</h1>

    <booking-menu />

    <div style="text-align: center">
      <div @click="$router.push('/booking/report/monthly')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;" x-large>insert_chart</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.reportMonthly") }}
        </h3>
      </div>
      <div @click="$router.push('/booking/report/organization-unit')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">gamepad</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.reportOrganizationUnit") }}
        </h3>
      </div>
      <div @click="$router.push('/booking/report/domestic-foreign')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">fa-globe</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <div style="height: 50px;">
          <h3>
            {{ $t("booking.reportDomesticForeign") }}
          </h3>
        </div>
      </div>
      <div @click="$router.push('/booking/report/passenger')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">emoji_people</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.reportPersons") }}
        </h3>
      </div>
      <div @click="$router.push('/booking/report/airline')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">airplanemode_active</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.airlineReport") }}
        </h3>
      </div>
      <div @click="$router.push('/booking/report/seat-class')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">airline_seat_recline_extra</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.bookingClass") }}
        </h3>
      </div>
      <div @click="$router.push('/booking/report/budget')" class="pa-4 text-md-center elevation-5 ma-4 report-buttons">
        <div style="padding-left: 45px;">
          <v-icon color="primary" style="font-size: 60px;">attach_money</v-icon>
          <v-btn color="success" x-small fab class="plus-button">
            <v-icon>fa-plus</v-icon>
          </v-btn>
        </div>
        <h3>
          {{ $t("booking.budgetUtilization") }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import BookingMenu from "../../components/Booking/BookingMenu.vue";

export default {
  name: "BookingReportView",
  components: { BookingMenu },
  data: () => ({
    search: ""
  }),
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped>
.report-buttons {
  background-color: rgb(245, 245, 245);
  width: 215px;
  height: 180px;
  display: inline-grid;
}

.report-flex {
  text-align: center;
  min-width: 215px;
}

.plus-button {
  position: relative;
  right: 15px;
  top: 15px;
}
</style>
